/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SeizableIncomeExplanationKind = {
    NoIncome: 'NoIncome',
    SingleStream: 'SingleStream',
    StreamSeizable: 'StreamSeizable',
    StreamSeizableWithPercentage: 'StreamSeizableWithPercentage',
    StreamFullyProtected: 'StreamFullyProtected',
    OtherStreamAlsoProtected: 'OtherStreamAlsoProtected',
    OtherStreamSeizableAfterDifference: 'OtherStreamSeizableAfterDifference',
    AliquotSplit: 'AliquotSplit',
    AliquotStreamProtected: 'AliquotStreamProtected',
    AliquotFullyProtected: 'AliquotFullyProtected'
} as const;
export type SeizableIncomeExplanationKind = typeof SeizableIncomeExplanationKind[keyof typeof SeizableIncomeExplanationKind];


export function instanceOfSeizableIncomeExplanationKind(value: any): boolean {
    for (const key in SeizableIncomeExplanationKind) {
        if (Object.prototype.hasOwnProperty.call(SeizableIncomeExplanationKind, key)) {
            if (SeizableIncomeExplanationKind[key as keyof typeof SeizableIncomeExplanationKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SeizableIncomeExplanationKindFromJSON(json: any): SeizableIncomeExplanationKind {
    return SeizableIncomeExplanationKindFromJSONTyped(json, false);
}

export function SeizableIncomeExplanationKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeizableIncomeExplanationKind {
    return json as SeizableIncomeExplanationKind;
}

export function SeizableIncomeExplanationKindToJSON(value?: SeizableIncomeExplanationKind | null): any {
    return value as any;
}

export function SeizableIncomeExplanationKindToJSONTyped(value: any, ignoreDiscriminator: boolean): SeizableIncomeExplanationKind {
    return value as SeizableIncomeExplanationKind;
}

